export default __webpack_public_path__ + "5d5386c95d1df94f2408cb916df1ca15.webp";